export default __webpack_public_path__ + "static/media/accountstmt.cf937cb2.svg";